// Cross-domain entity lifecycle. Persisted as `smallint` so it's compact,
// cheaply indexed, and ordered (higher number = closer to terminal). The
// `Archived` value is reserved in the type and the DB CHECK constraints but
// no domain currently exposes a transition into it — adding that flow later
// is a code-only change.

export const LifecycleStatus = {
  Active: 0,
  Inactive: 1,
  Archived: 2,
} as const satisfies Record<string, number>;

export type LifecycleStatus = (typeof LifecycleStatus)[keyof typeof LifecycleStatus];

export const LIFECYCLE_STATUS_VALUES = [
  LifecycleStatus.Active,
  LifecycleStatus.Inactive,
  LifecycleStatus.Archived,
] as const satisfies readonly LifecycleStatus[];

export const LIFECYCLE_STATUS_LABELS: Record<LifecycleStatus, string> = {
  [LifecycleStatus.Active]: 'Active',
  [LifecycleStatus.Inactive]: 'Inactive',
  [LifecycleStatus.Archived]: 'Archived',
};

export function isLifecycleStatus(value: unknown): value is LifecycleStatus {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    (LIFECYCLE_STATUS_VALUES as readonly number[]).includes(value)
  );
}

export function lifecycleStatusLabel(value: LifecycleStatus): string {
  return LIFECYCLE_STATUS_LABELS[value];
}
